export default __webpack_public_path__ + "static/media/noun-location-point-4457421.70d5328b.svg";